import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { AIAgentTemplates } from '../../containers/AIAgentTemplates';

export const AdminAgentTemplatesPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<AIAgentTemplates />
		</AdminDashboardPageLayout>
	);
};
